"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grid.default;
  }
});

var _Grid = _interopRequireDefault(require("./Grid"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Grid/index.js
// module id = 42
// module chunks = 0